import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ConfirmCancelModalProps {
  title: string;
  subtitle: string;
  confirm: string;
  cancel: string;
  confirmCallback?: () => void;
}

export const ConfirmCancelModal = ({
  title,
  subtitle,
  confirm,
  cancel,
  confirmCallback,
}: ConfirmCancelModalProps) => {
  return (
    <AlertDialogContent>
      <AlertDialogHeader className="text-left">
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-system-gray-light">
          {subtitle}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="text-primary-brand-light">
          {cancel}
        </AlertDialogCancel>
        <AlertDialogAction onClick={confirmCallback}>
          {confirm}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
};
